import { createIcon } from '../icon'
import DiscountSmallIcon from '../svg/DiscountSmallIcon'

export const DiscountSmallIconDefault = createIcon(DiscountSmallIcon)
